import axios, { AxiosError, AxiosRequestHeaders } from "axios";
import { trackAxiosErrorWithSentry } from "sentry";

import { getAPIUrl } from "shared/utils/api-utils";
import { defaultHeaders, getAuthHeaders } from "shared/utils/auth-utils";

const clientServer = axios.create({
  baseURL: getAPIUrl("ai"),
});

clientServer.interceptors.request.use((config) => ({
  ...config,
  headers: {
    ...defaultHeaders,
    ...getAuthHeaders(),
    ...config.headers,
  } as AxiosRequestHeaders,
  withCredentials: true,
}));

clientServer.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    trackAxiosErrorWithSentry(error, "ai_server");

    return Promise.reject(error);
  }
);

const getPydanticAIChatHeaders = (): Record<string, string> => ({
  ...defaultHeaders,
  ...getAuthHeaders(),
});

export { clientServer, getPydanticAIChatHeaders };
